// extracted by mini-css-extract-plugin
module.exports = {"btn":"comment-button_btn__R4xM0","iconBtn":"comment-button_iconBtn__oKi6x"};